export default {
    'searchList': {
        'searchTxt': [{
            'name': '供应商编码',
            'value': 'supplierCode',
            'type': 'input',
            'unfold': true,
            'span': 3,
            'multiple': false
        },
        {
            'name': '供应商名称',
            'value': 'supplierNameCn',
            'type': 'input',
            'unfold': true,
            'span': 3,
            'multiple': false
        },
        {
            'name': '账号类型',
            'value': 'accountType',
            'type': 'select',
            'unfold': true,
            'options': [
                {
                    label: '供应商',
                    value: '1'
                },
                {
                    label: '司机',
                    value: '2'
                },
                {
                    label: '银行',
                    value: '3'
                }
            ],
            'span': 3,
            'multiple': false
        },
        {
            'name': '是否分配账号',
            'value': 'distributionCode',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'options': [
                {
                    label: '是',
                    value: '0'
                },
                {
                    label: '否',
                    value: '1'
                }
            ],
            'multiple': false
        },
        {
            'name': '手机号',
            'value': 'contactsMobile',
            'type': 'input',
            'unfold': true,
            'span': 3
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'searchTotalTitle': [
        {
            'name': '用户类型',
            'value': 'userType',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'options': [
                {
                    label: '主账号',
                    value: '1'
                },
                {
                    label: '子账号',
                    value: '2'
                }

            ],
            'multiple': false
        },
        {
            'name': '账号',
            'value': 'userCode',
            'type': 'input',
            'unfold': true,
            'span': 3,
            'multiple': false
        },
        {
            'name': '账号状态',
            'value': 'contactsStatus',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'options': [
                {
                    label: '启用',
                    value: '0'
                },
                {
                    label: '停用',
                    value: '1'
                }

            ],
            'multiple': false
        }],
    'table':
    {
        'switchType': true,
        'tableCut': false,
        'clickState': true,
        'selectBtn': true,
        'height': 400,
        'statesY': '启用',
        'statesN': '停用',
        'columns': [
            {
                'label': '供应商商编号',
                'prop': 'supplierCode',
                'width': '150px'
            },
            {
                'label': '供应商名称',
                'prop': 'supplierNameCn',
                'width': '200px'
            },
            {
                'label': '供应商状态',
                'prop': 'supplierStatus',
                'width': '200px'
            },
            {
                'label': '联系人姓名',
                'prop': 'contacts',
                'width': '200px'
            },
            {
                'label': '手机号',
                'prop': '_contactsMobile',
                'width': '200px'
            },
            {
                'label': '身份证号',
                'prop': '_idCard',
                'width': '200px'
            },
            {
                'label': '对公邮箱',
                'prop': 'contactsEmail',
                'width': '200px'
            },
            {
                'label': '职务',
                'prop': 'contactsPost',
                'width': '200px'
            },
            {
                'label': '办公地址',
                'prop': 'contactsAddress',
                'width': '200px'
            },
            {
                'label': '账号',
                'prop': 'userCode',
                'width': '200px'
            },
            {
                'label': '用户类型',
                'prop': 'userType',
                'width': '200px'
            },
            {
                'label': '账号类型',
                'prop': 'accountType',
                'width': '200px'
            },
            {
                'label': '账号角色',
                'prop': 'roleNameJson',
                'width': '200px'
            },
            {
                'label': '状态',
                'prop': 'contactsStatus',
                'width': '200px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '200px'
            },
            {
                'label': '创建人',
                'prop': 'createUserName',
                'width': '200px'
            },
            {
                'label': '修改人',
                'prop': 'updateUserName',
                'width': '200px'
            }],
        'action':
            [{
                'type': 'text',
                'label': '权限分配',
                'size': 'mini',
                'event': 'permission',
                'ifHas': '04000203'
            },
            {
                'type': 'text',
                'label': '生成账号',
                'size': 'mini',
                'event': 'create-account',
                'ifHas': '04000204'
            },
            {
                'type': 'text',
                'label': '重置密码',
                'size': 'mini',
                'event': 'reset-password',
                'ifHas': '04000205'
            },
            {
                'type': 'text',
                'label': '绑定租户',
                'size': 'mini',
                'event': 'bind-tenant',
                'ifHas': '04000208'
            }],
        'leftOperation': true,
        'leftWidth': 220
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
